import React, { Component } from 'react';
import styled from 'styled-components';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm } from 'rc-form';
import { colors } from '../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../constants/text';
import TextField from '../../../../SolvPatternLibrary/TextField';
import { isEmptyObject } from '../../../../../core/util/object';
import { Actions, Events } from '../../../util/analytics';
import { analyticsTrackEvent } from '../../../../../core/analytics';

export const PRESCRIPTIONS_FIELD = 'prescriptions';
export const ADDITIONAL_NOTES_FIELD = 'additional-notes';

const Root = styled.div.withConfig({ componentId: 'sc-wrb8bq-0' })`
  padding: 16px;
  border-bottom: 1px solid ${colors.borderLine};
`;

const H2 = styled.h2.withConfig({ componentId: 'sc-wrb8bq-1' })`
  font-size: ${fontSize.default};
  font-family: ${fontFamily.bold};
  color: ${colors.squid};
`;

const P = styled.p.withConfig({ componentId: 'sc-wrb8bq-2' })`
  color: ${colors.lightText};
  margin: 4px 0 14px;
`;

const NotesField = styled(TextField).withConfig({ componentId: 'sc-wrb8bq-3' })`
  width: 100%;
  margin: 4px 0 16px;
  background: ${colors.theWhiteAlbum};
  overflow: hidden;

  & .input-root {
    height: 32px;
    padding: 8px 12px;
    text-indent: 0;
    font-size: ${fontSize.mediumSmall};
  }
`;

const ActionButton = styled.label.withConfig({ componentId: 'sc-wrb8bq-4' })`
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueJayWay};
  font-family: ${fontFamily.bold};
  cursor: pointer;
  text-transform: uppercase;
`;

const ButtonsContainer = styled.div.withConfig({ componentId: 'sc-wrb8bq-5' })`
  display: flex;
  width: 120px;
  justify-content: space-between;
`;

type Props = {
  notesResult?: any;
  notes?: string;
  prescriptions?: string;
  saveBookingNotes?: (...args: any[]) => any;
  updateBookingNotes?: (...args: any[]) => any;
  form?: any;
};

type State = any;

class VisitNotes extends Component<Props, State> {
  state = { showForm: false };

  onClickAddOrEdit = () => {
    const action = this.isEmptyNotes() ? Actions.CLICK_ADD_NOTES : Actions.CLICK_EDIT_NOTES;
    analyticsTrackEvent(Events.BOOKING_NOTES, { action });
    this.setState({ showForm: true });
  };

  onClickCancel = () => {
    analyticsTrackEvent(Events.BOOKING_NOTES, {
      action: Actions.CLICK_CANCEL_NOTES,
    });
    this.setState({ showForm: false });
  };

  onClickSave = () => {
    const {
      saveBookingNotes,
      updateBookingNotes,
      form: { getFieldsValue },
    } = this.props;

    analyticsTrackEvent(Events.BOOKING_NOTES, {
      action: Actions.CLICK_SAVE_NOTES,
    });

    if (this.isEmptyNotes()) {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      saveBookingNotes(getFieldsValue(), () => this.setState({ showForm: false }));
    } else {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      updateBookingNotes(getFieldsValue(), () => this.setState({ showForm: false }));
    }
  };

  getPrescriptionsProps = () => {
    const {
      prescriptions,
      form: { getFieldProps, setFieldsValue },
    } = this.props;

    return {
      ...getFieldProps(PRESCRIPTIONS_FIELD, { initialValue: prescriptions }),
      id: PRESCRIPTIONS_FIELD,
      placeholder: 'Add your medication notes here...',
      onChange: ({ target: { id, value } }: any) => setFieldsValue({ [id]: value }),
    };
  };

  getAdditionalNotesProps = () => {
    const {
      notes,
      form: { getFieldProps, setFieldsValue },
    } = this.props;

    return {
      ...getFieldProps(ADDITIONAL_NOTES_FIELD, { initialValue: notes }),
      id: ADDITIONAL_NOTES_FIELD,
      placeholder: 'Add any additional notes here...',
      onChange: ({ target: { id, value } }: any) => setFieldsValue({ [id]: value }),
    };
  };

  isEmptyNotes = () => isEmptyObject(this.props.notesResult);

  render = () => {
    const { notes, prescriptions } = this.props;
    const { showForm } = this.state;

    return (
      <Root>
        {showForm ? (
          <div>
            <H2>Medication notes</H2>

            <NotesField {...this.getPrescriptionsProps()} classes={{ inputInput: 'input-root' }} />

            <H2>Additional notes</H2>

            <NotesField
              {...this.getAdditionalNotesProps()}
              classes={{ inputInput: 'input-root' }}
            />

            <ButtonsContainer>
              <ActionButton onClick={this.onClickSave}>Save</ActionButton>

              <ActionButton onClick={this.onClickCancel}>Cancel</ActionButton>
            </ButtonsContainer>
          </div>
        ) : (
          <div>
            <H2>Medication notes</H2>

            <P>{prescriptions || 'N/A'}</P>

            <H2>Additional notes</H2>

            <P>{notes || 'N/A'}</P>

            <ActionButton onClick={this.onClickAddOrEdit}>
              {this.isEmptyNotes() ? 'Add' : 'Edit'}
            </ActionButton>
          </div>
        )}
      </Root>
    );
  };
}

export default createForm()(VisitNotes);
